<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="400px">
    <template v-slot:activator="{ on }">
      <v-tooltip left>
        <template v-slot:activator="{ on }" v-if="permissions.edit">
          <v-btn
            v-show="addButton"
            class="mt-5 mr-2"
            v-on="on"
            absolute
            dark
            fab
            top
            right
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar checklist</span>
      </v-tooltip>
      <!-- <v-btn color="primary" dark class="mb-2" @click="openForm()">Novo Cliente</v-btn> -->
    </template>
    
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="resetDialog">close</v-icon>
      </v-system-bar>

      <v-card-title class="mb-0 pb-0">
        <span
          class="title grey--text text--darken-2"
        >
          {{ formData.id ? 'Editar checklist' : 'Novo checklist' }}
        </span>
      </v-card-title>

      <v-card-text class="mt-0 pt-0">
        <v-form ref="serviceForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
          <v-container grid-list-md pl-1>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  :disabled="viewForm"
                  type="text"
                  v-model="formData.name"
                  label="Nome do checklist"
                  :rules="$store.state.formRules.required"
                  @keydown.enter.prevent
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="resetDialog">Cancelar</v-btn>
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const defaultForm = {
  name: ""
};

export default {
  name: "ChecklistForm",

  props: {
    addButton: Boolean,
    openForm: Function,
    closeForm: Function,
    saveService: Function,
    dialog: Boolean,
    editFormData: Object
  },
  
  data () {
    return {
      viewForm: false,
      permissionsList: [],
      formData: { ...defaultForm },
      validForm: true
    };
  },

  computed: {
    permissions () {
      return this.$store.state.permissions.permissions.standardSystem
    },
    dialogShow() {
      return this.dialog;
    }
  },
  
  watch: {
    dialogShow (val) {
      if (val) {
        if (this.$props.editFormData) {
          if (this.$props.editFormData.view) {
            this.viewForm = true;
          } else {
            this.viewForm = false;
          }
          this.formData = {
            ...this.editFormData
          };
        }
      } else {
        this.viewForm = false;
        this.$refs.serviceForm.resetValidation();
        this.formData = { ...defaultForm };
      }
    }
  },

  methods: {
    resetDialog() {
      this.$props.closeForm();
    },

    doSave() {
      if (!this.$refs.serviceForm.validate()) {
        return;
      }

      const callback = function() {
        this.$props.closeForm();
      };

      this.$props.saveService(this.formData, callback);
    }
  }
};
</script>

<style>
.permissionTitle.red--text,
.permissionTitle.red--text::before {
  content: "*";
  color: #f44336 !important;
}
</style>
